'use es6';

const CRITIAL_ASSET_TAGS = ['SCRIPT', 'LINK'];

// Same for public_common.js (in head before IPEUI's JS bundle)
// /\/hs\/hsstatic\/content_shared_assets\/static-\d+\.\d+\/css\/public_common.css/,

export const CRITIAL_ASSET_URL_REGEXES = [
// Inpage JS/CSS code
/\/InpageEditorUI\/static(-\d+(?:-\w+-?)*\.\d+)\/bundles\//,
// Default CMS styling
/\/hubspot_default\/shared\/responsive\/layout.min.css/,
// Core CMS internationaliztion utils
/\/(hs\/hsstatic|static.hsstatic.net)\/cos-i18n\/static(-\d+(?:-\w+-?)*\.\d+)\/bundles\/project.js/,
// Forms embed code
/\/(_hcms|js.hsforms.net)\/forms\/v2.js/];
const critialAssetsWithError = [];
const handleAssetErrors = error => {
  const element = error.target;
  if (element && CRITIAL_ASSET_TAGS.includes(element.tagName)) {
    const assetUrl = element.tagName === 'LINK' ? element.href : element.src;
    if (CRITIAL_ASSET_URL_REGEXES.some(regex => regex.test(assetUrl))) {
      critialAssetsWithError.push(assetUrl);
      console.error(`Critial preview asset failed to load: ${assetUrl}`);
    }
  }
};
export const attachCritialAssetHandler = () => {
  window.addEventListener('error', handleAssetErrors, true);
};
export const collectAndFinishWaitingForCritialAssets = () => {
  window.removeEventListener('error', handleAssetErrors, true);
  return critialAssetsWithError;
};
let beforeUnloadHandler;
const tellParentTheIframeIsUnloading = callback => {
  beforeUnloadHandler = () => {
    // Intentionally not triggering the "Are you sure you want to leave" prompt
    // just using this to send some data to the parent app
    callback();
  };
  return beforeUnloadHandler;
};
export const attachRedirectDetector = callback => {
  window.addEventListener('beforeunload', tellParentTheIframeIsUnloading(callback));
};
export const detachRedirectDetector = () => {
  if (beforeUnloadHandler) {
    window.removeEventListener('beforeunload', beforeUnloadHandler);
  }
};

// If this file has run, but document ready hasn't fired yet (due to slow
// loading blocking scripts), then attempt to figure out what resources are
// loading slow, and post message them to the parent frame
export const attachSlowDomReadyHandler = callback => {
  if (document.readyState === 'loading') {
    setTimeout(() => {
      if (document.readyState === 'loading') {
        const possibleBlockingScriptElements = document.querySelectorAll('script[src]');
        const possibleBlockingStyleSheets = document.querySelectorAll('link[rel="stylesheet"]');
        const lastResourcesDetected = {};
        if (possibleBlockingScriptElements.length) {
          const lastJsResourceDetected = possibleBlockingScriptElements[possibleBlockingScriptElements.length - 1];
          lastResourcesDetected.js = {
            url: lastJsResourceDetected.src
          };
        }
        if (possibleBlockingStyleSheets.length) {
          const lastCssResourceDetected = possibleBlockingStyleSheets[possibleBlockingStyleSheets.length - 1];
          lastResourcesDetected.css = {
            url: lastCssResourceDetected.href
          };
        }
        callback(lastResourcesDetected);
      }
    }, 10000);
  }
};